import { $, $doc, debounceResize } from './_utils';

function recalculatePositionSlide($item, $slide) {
  if ($item.length && $slide.length) {
    const hasVerticalClass = $item
      .closest('.is-style-vpth-tabs')
      .hasClass('ghostkit-tabs-buttons-vertical');
    if (!hasVerticalClass) {
      $slide.css({
        width: $item.innerWidth(),
        transform: `translate(${
          $item.position().left + parseInt($item.css('margin-left'), 10)
        }px, ${$item.position().top + $item.innerHeight()}px)`,
      });
    } else if (hasVerticalClass && 768 < window.innerWidth) {
      $slide.css({
        height: $item.innerHeight(),
        transform: `translate(${$item.position().left + $item.innerWidth()}px, ${
          $item.position().top
        }px)`,
      });
    } else if (hasVerticalClass && 768 > window.innerWidth) {
      $slide.css({
        width: $item.innerWidth(),
        transform: `translate(${
          $item.position().left + parseInt($item.css('margin-left'), 10)
        }px, ${$item.position().top + $item.innerHeight()}px)`,
      });
    }
  }
}

function createSlide($list, $itemActive, parentClass) {
  const $tabsItemsList = $list;
  const $tabsItemActive = $itemActive;

  // create
  if (!$tabsItemsList.children('.vpth-tabs-slide').length) {
    $tabsItemsList.append('<span class="vpth-tabs-slide"></span>');
  }

  const $tabsSlide = $tabsItemsList.children('.vpth-tabs-slide');

  recalculatePositionSlide($tabsItemActive, $tabsSlide);

  setTimeout(() => {
    $tabsItemsList.parents(parentClass).addClass('vpth-tabs-ready');
  }, 10);
}

// Ghostkit create and position slide
$doc.on('activateTab.ghostkit', (event) => {
  if ('ghostkit' !== event.namespace) {
    return;
  }

  $('.is-style-vpth-tabs:not(.vpth-tabs-ready) > .ghostkit-tabs-buttons').each(function () {
    const $tabsItemsList = $(this);
    const $tabsItemActive = $tabsItemsList.children('.ghostkit-tabs-buttons-item-active');

    createSlide($tabsItemsList, $tabsItemActive, '.is-style-vpth-tabs');
  });
});

// update position on resize
debounceResize(() => {
  $('.is-style-vpth-tabs.vpth-tabs-ready > .ghostkit-tabs-buttons').each(function () {
    const $tabsItemList = $(this);
    const $tabsItemActive = $tabsItemList.children('.ghostkit-tabs-buttons-item-active, .active');
    const $tabsSlide = $tabsItemList.children('.vpth-tabs-slide');

    recalculatePositionSlide($tabsItemActive, $tabsSlide);
  });
});

// position slide on click
$doc.on('click', '.is-style-vpth-tabs.vpth-tabs-ready > .ghostkit-tabs-buttons', function () {
  const $tabsItemList = $(this);
  const $tabsItemActive = $tabsItemList.children('.ghostkit-tabs-buttons-item-active, .active');
  const $tabsSlide = $tabsItemList.children('.vpth-tabs-slide');

  recalculatePositionSlide($tabsItemActive, $tabsSlide);
});
